export const APP_NAME = "Shesha Boilerplate";

export const ACCESS_TOKEN_NAME = "xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv";

export const LOGO = {
  src: "https://uploads-ssl.webflow.com/61423df7fefcfd4536b14230/62b0726b03457b202b625d0d_Boxfusion_logo.png",
  width: 200,
};
